<template>
  <Select
    :items="arrayStatus"
    :selectedItem="filter.status"
    label="Status"
    searchPlaceholder="Buscar status"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :filtro_default="filtro.default"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      filter: {
        status: {
          id: "",
          name: "",
        },
      },
      arrayStatus: [
        { id: "em_digitacao", name: "Em Digitação" },
        { id: "transmitida", name: "Transmitida" },
        { id: "rejeitada", name: "Rejeitada" },
      ],
    };
  },
  methods: {
    atualizar(status) {
      this.filter.status = status;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.status.id, this.path);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.status.id
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.arrayStatus, this.filter.status);
  },
}
</script>
